<template>
  <v-container fluid>
    <div style="text-align: center;" class="display-1 font-weight-thin">Solicitação para Prestação de Contas</div>

    <v-snackbar auto-height v-model="snackbar.ativo" :timeout="snackbar.timeout" top right :color="snackbar.color">{{
      snackbar.text }}</v-snackbar>

    <v-layout row wrap>
      <v-flex xs12 style="height: 100%" v-if="solicitacaoParaPrestarContas.motivoDaReprovacao != ''">
        <v-container class="pb-0 pt-3">
          <v-toolbar class="red lighten-1">
            <v-toolbar-title class="white--text">Motivo reprovação</v-toolbar-title>
          </v-toolbar>

          <v-content class="red lighten-2">
            <v-form>
              <v-layout row wrap>
                <v-flex md12 xs12>
                  <v-textarea label="Reprovação" prepend-icon="note"
                    v-model="solicitacaoParaPrestarContas.motivoDaReprovacao" readonly></v-textarea>
                </v-flex>
              </v-layout>
            </v-form>
          </v-content>
        </v-container>
      </v-flex>

      <v-flex xs12 style="height: 100%">
        <v-container class="pt-3">
          <integracao-mensagem :mensagemIntegracao="solicitacaoParaPrestarContas.mensagemIntegracao"
            :statusIntegracao="solicitacaoParaPrestarContas.statusIntegracao"
            @chamaFuncao="prepararRequest('APROVAR')"></integracao-mensagem>

          <v-toolbar class="blue-grey lighten-4 elevation-2">
            <v-toolbar-title>Dados Gerais</v-toolbar-title>
          </v-toolbar>

          <v-content class="grey lighten-4">
            <v-form v-model="validacaoDadosGerais" ref="formDadosGerais">
              <v-layout row wrap>
                <v-flex md3 xs12>
                  <v-autocomplete label="Moeda" v-model="solicitacaoParaPrestarContas.tipoDeMoeda"
                    prepend-icon="monetization_on" :rules="regraTipoDeMoeda" :items="tiposDeMoeda" item-text="nome"
                    item-value="valor" :readonly="!podeEditar"
                    @change="alteraCampoValorRecebido($event)"></v-autocomplete>
                </v-flex>
                <v-flex md3 xx12>
                  <v-text-field label="Valor Recebido em Adiantamento"
                    v-model="solicitacaoParaPrestarContas.valorDoAdiantamento" @blur="formataValorRecebidoDeAdiantamento"
                    :rules="regraValorDoAdiantamento" :readonly="!podeEditar"></v-text-field>
                </v-flex>

                <v-flex md3 xx12>
                  <v-text-field label="Valor a ser devolvido para a empresa" v-model="calculaValorAhDevolver"
                    :readonly="true"></v-text-field>
                </v-flex>

                <v-flex md3 xx12>
                  <v-text-field label="Valor a ser pago para o colaborador" v-model="calculaValorAcrescido"
                    :readonly="true"></v-text-field>
                </v-flex>

                <v-flex md6 xs12>
                  <v-autocomplete label="Selecione a Empresa" append-icon="business_center"
                    v-model="solicitacaoParaPrestarContas.idDaEmpresa" :loading="loadingCompanies"
                    :items="empresas.content" item-value="id" item-text="nome" :rules="regraEmpresa"
                    :readonly="!podeEditar" :disabled="solicitacaoParaPrestarContas.despesas.length >= 1">
                    <template slot="selection" slot-scope="data">{{ data.item.id }} - {{ data.item.nome }}</template>
                    <template slot="item" slot-scope="data">{{ data.item.id }} - {{ data.item.nome }}</template>
                    <template slot="no-data">
                      <div class="noDataSlot">Nenhuma empresa cadastrada</div>
                    </template>
                  </v-autocomplete>
                </v-flex>

                <v-flex md6 xx12>
                  <v-text-field label="Número do Pedido" v-model="solicitacaoParaPrestarContas.numeroDoPedido"
                    :readonly="!podeEditar && !verificaPerfilFinanceiro" :rules="regraNumeroDoPedido"></v-text-field>
                </v-flex>

                <v-flex md12 xs12>
                  <v-textarea label="Finalidade" prepend-icon="note" v-model="solicitacaoParaPrestarContas.finalidade"
                    :readonly="!podeEditar" :rules="finalidadeRules" class="mb-2"></v-textarea>
                </v-flex>
              </v-layout>
            </v-form>
          </v-content>

          <!-- Componente de Despesas estará localizado aqui -->
          <v-divider class="mx-6 my-2" inset dark></v-divider>

          <component-despesas :despesasCadastradas="solicitacaoParaPrestarContas.despesas" :podeEditar="podeEditar"
            :ehAprovador="ehAprovador" :idDaEmpresa="solicitacaoParaPrestarContas.idDaEmpresa"
            :tipoDeMoeda="solicitacaoParaPrestarContas.tipoDeMoeda"
            @gastos="solicitacaoParaPrestarContas.despesas = $event"></component-despesas>

          <v-divider class="mx-6 my-2" inset dark></v-divider>

          <v-content class="grey lighten-4">
            <v-toolbar class="blue-grey lighten-4 elevation-2">
              <v-toolbar-title>Anexos</v-toolbar-title>
            </v-toolbar>
            <v-layout row wrap style="padding: 25px;">
              <v-flex md12 xs12 class="text-xs-center">
                <i>Documentos fiscais que não são eletrônicos devem constar cópia em anexo e via original para ser
                  entregue no financeiro</i>
              </v-flex>
              <v-layout row wrap justify-center>
                <v-flex xs9>
                  <div class="text-xs-center" v-if="solicitacaoParaPrestarContas.uploads.length > 0 &&
                    solicitacaoParaPrestarContas.status != ''">
                    <div v-for="(upload, index) in solicitacaoParaPrestarContas.uploads" :key="upload.id">
                      <a target="_blank"
                        :href="urlParaUpload + `/uploads/${upload.nomeDoArquivo}`">{{ upload.nomeDoArquivo.split(/-(.+)/)[1] }}</a>
                      <v-btn @click.prevent="solicitacaoParaPrestarContas.uploads.splice(index, 1)" color="red" flat small
                        style="padding-left: 0px; margin-left: 0px;"
                        v-if="verificaAnexoContabilidade || verificaPerfilFinanceiro">
                        <v-icon>delete</v-icon>Remover
                      </v-btn>
                    </div>
                  </div>
                  <v-list class="blue-grey lighten-5" v-if="verificaAnexoContabilidade || verificaPerfilFinanceiro">
                    <v-subheader>Novos Arquivos Anexados: {{ arquivoAnexado.length }}</v-subheader>
                    <v-divider color="#F0F0F0"></v-divider>
                    <v-list-tile v-for="(itemAnexado, index) in arquivoAnexado">
                      <v-list-tile-title style="height: auto !important;">
                        {{ Number(index) + 1 }} - {{ itemAnexado.name }}
                        <v-btn @click.prevent="arquivoAnexado.splice(index, 1)" color="red" flat small
                          style="padding-left: 0px; margin-left: 0px;float: right;">
                          <v-icon>delete</v-icon>Remover
                        </v-btn>
                      </v-list-tile-title>
                    </v-list-tile>
                  </v-list>
                  <div class="text-xs-center" v-if="verificaAnexoContabilidade || verificaPerfilFinanceiro">
                    <input accept="image/jpeg, image/png, application/pdf" style="display: none;" type="file" ref="files"
                      multiple @change="upload('files')" />
                    <v-btn color="#005ca3" @click="enviarArquivoClique()">Anexar Arquivo</v-btn>
                  </div>
                  <div v-if="msgErroAnexo != ''" class="text-xs-center mb-2">
                    <span style="color: red; ">{{ msgErroAnexo }}</span>
                  </div>
                </v-flex>
              </v-layout>
            </v-layout>
          </v-content>

          <v-divider class="mx-6 my-2" inset dark></v-divider>

          <c-box-fornecedor @receberBusca="solicitacaoParaPrestarContas.cnpj_cpf = $event"
            @receberFornecedor="receberFornecedor($event)" :fornecedorRecebido="fornecedorRecebido"
            :podeEditar="podeEditar"></c-box-fornecedor>

          <v-divider class="mx-6 my-2" inset dark></v-divider>
          <v-content v-if="solicitacaoParaPrestarContas.observacao != '' || ehAprovador">
            <v-toolbar class="yellow lighten-3">
              <v-toolbar-title>Observações</v-toolbar-title>
            </v-toolbar>

            <v-content class="yellow lighten-4">
              <v-form>
                <v-layout row wrap>
                  <v-flex md12 xs12>
                    <v-textarea v-model="solicitacaoParaPrestarContas.observacao" name="name" prepend-icon="note"
                      :readonly="!ehAprovador || !podeVisualizar()"></v-textarea>
                  </v-flex>
                </v-layout>
              </v-form>
            </v-content>
          </v-content>

          <!-- operações do solicitante -->
          <v-card-actions v-if="podeEditar">
            <v-spacer></v-spacer>
            <v-btn style="font-weight: bold;" color="indigo darken-4" flat :loading="loadingRequest"
              @click.native="buscarAprovadores" :disabled="!passouNasRegrasDeValidacao">Enviar para aprovação</v-btn>
          </v-card-actions>

          <v-dialog @keydown.esc="dialogoAprovador = false" v-model="dialogoAprovador" max-width="500px">
            <v-card>
              <v-card-title>
                <span class="headline">Selecione um aprovador</span>
              </v-card-title>

              <v-card-text>
                <v-form onsubmit="return false;">
                  <v-autocomplete label="Selecione um aprovador" v-model="aprovadorSelecionado"
                    :loading="loadingAprovador" :items="aprovadores" item-text="nome" item-value="id">
                    <template slot="no-data">
                      <div class="noDataSlot">Nenhum aprovador encontrado.</div>
                    </template>
                  </v-autocomplete>
                </v-form>
              </v-card-text>

              <v-card-actions style="background-color: #fff">
                <v-spacer></v-spacer>
                <v-btn color="pink" flat v-if="!loadingRequest" @click.native="fechar">Cancelar</v-btn>

                <v-progress-circular indeterminate color="blue" v-if="loadingRequest"></v-progress-circular>

                <v-btn color="indigo darken-4" flat v-if="!loadingRequest"
                  @click.native="prepararRequest('ENVIAR_PARA_APROVACAO')">Enviar</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
          <v-card-actions v-if="ehAprovador && podeVisualizar()">
            <v-spacer></v-spacer>
            <v-progress-circular class="mr-2" indeterminate color="primary" v-if="loadingRequest"></v-progress-circular>

            <v-btn :disabled="loadingRequest" color="error"
              @click.native="dialogConfirmarReprovacao = true">Reprovar</v-btn>

            <v-btn v-if="solicitacaoParaPrestarContas.status != 'APROVADO_PELO_PROCURADOR'" :disabled="loadingRequest"
              color="success" @click.native="dialogConfirmarAprovacao = true">Aprovar</v-btn>
          </v-card-actions>

          <v-dialog v-model="dialogConfirmarReprovacao" max-width="500px">
            <v-card style="background-color: #eceff1">
              <v-card-title class="error">
                <span class="mx-auto text-center" style="font-size: 1.4em;color: white">Digite o motivo da
                  reprovação</span>
              </v-card-title>

              <v-card-text>
                <v-form>
                  <v-textarea background-color="#cfd8dc" color="error"
                    v-model="solicitacaoParaPrestarContas.motivoDaReprovacao"></v-textarea>
                </v-form>
                <v-layout row wrap>
                  <v-btn color="error" class="ml-0" @click="dialogConfirmarReprovacao = false">Cancelar</v-btn>
                  <v-spacer></v-spacer>
                  <v-btn color="primary" class="mr-0" @click="prepararRequest('REPROVAR')">Reprovar</v-btn>
                </v-layout>
              </v-card-text>
            </v-card>
          </v-dialog>

          <v-dialog v-model="dialogConfirmarAprovacao" max-width="500px">
            <v-card style="background-color: #005ca3;">
              <v-card-title primary-title class="pb-0">
                <p class="title font-weight-medium text-center mx-auto" style="color: white;">{{
                  retornaTextoCorretoParaFinanceiro }}</p>
              </v-card-title>
              <v-card-text class="pt-0">
                <v-layout row wrap v-if="solicitacaoParaPrestarContas.status != 'REPROVADO_PELO_PROCURADOR'" class="pb-2">
                  <v-btn color="white" class="ml-5" @click="dialogConfirmarAprovacao = false">Não</v-btn>
                  <v-spacer></v-spacer>
                  <v-btn color="white" class="mr-5" @click="prepararRequest('APROVAR')">Sim</v-btn>
                </v-layout>

                <v-layout row wrap class="pb-2" v-else>
                  <v-btn color="white" class="ml-5"
                    @click="prepararRequest('ENVIADO_PARA_CONTABILIDADE')">Contabilidade</v-btn>
                  <v-spacer></v-spacer>
                  <v-btn color="white" class="mr-5" @click="prepararRequest('ENVIADO_PARA_PROCURADOR')">Procurador</v-btn>
                </v-layout>
              </v-card-text>
            </v-card>
          </v-dialog>

          <logs-pedidos class="mt-3" v-if="solicitacaoParaPrestarContas.logs != null"
            :logs="solicitacaoParaPrestarContas.logs"></logs-pedidos>
        </v-container>
      </v-flex>
    </v-layout>
  </v-container>
</template>
<script>
import Despesas from "@/components/solicitacao/Despesas.vue";
import axios from "axios";
import LogsPedidos from "@/components/solicitacao/LogsPedidos.vue";
import IntegracaoMensagem from "@/components/shared/IntegracaoMensagem.vue";
import RateioDespesas from "@/components/solicitacao/RateioDeDespesas.vue";
import BoxFornecedor from "@/components/solicitacao/BoxFornecedor.vue";
import conversor from "../../../mixins/moedasMixin.js";
import { substituirCaracteres } from '../../../mixins/validarCampos.js';
import { validarSeUsuarioLogadoPodeVerPedido } from "@/mixins/visualizacaoPedidos.js";
import { converterLogParaHorarioDeSaoPaulo } from "@/mixins/dateMixin.js";

export default {
  data() {
    return {
      urlParaUpload: process.env.VUE_APP_API_BACKEND,
      msgErroAnexo: "",
      loadingBusca: false,
      validacaoDadosGerais: false,
      podeEditar: true,
      usuarioLogado: null,
      ehAprovador: false,
      statusDoFornecedor: "",
      solicitacaoParaPrestarContas: {
        idDoSolicitante: null,
        idDoAprovador: null,
        total: null,
        idDaEmpresa: null,
        tipoDeMoeda: "BRL",
        valorDoAdiantamento: 0,
        valorAhDevolver: 0,
        valorAcrescido: 0,
        numeroDoPedido: null,
        finalidade: "",
        banco: null,
        agencia: null,
        contaCorrente: null,
        favorecido: null,
        cnpj_cpf: null,
        despesas: [],
        pagamento: {
          conta: {
            id: null
          }
        },
        uploads: [],
        observacao: "",
        motivoDaReprovacao: "",
        status: "",
        idDoFornecedor: null
      },
      arquivoAnexado: "",
      tiposDeMoeda: [
        {
          valor: "BRL",
          nome: "R$ - Real Brasileiro"
        },
        {
          valor: "USD",
          nome: "US$ - Dólar dos EUA"
        },
        {
          valor: "AUD",
          nome: "A$ - Dólar Australiano"
        },
        {
          valor: "CAD",
          nome: "C$ - Dólar do Canadá"
        },
        {
          valor: "JPY",
          nome: "¥ - Iene"
        },
        {
          valor: "EUR",
          nome: "€ - Euro"
        },
        {
          valor: "GBP",
          nome: "£ - Libra"
        },
        {
          valor: "SGD",
          nome: "S$ - Dólar da Singapura"
        },
        {
          valor: "MXN",
          nome: "Mex$ - Peso Mexicano"
        }
      ],
      finalidadeRules: [
        // Desculpe por isso meu eu do futuro :(
        finalidade => {
          if (finalidade.length <= 10) {
            return "Finalidade deve ter no mínimo 10 caracteres."
          }
          if (finalidade.length > 255) {
            return `Finalidade excedeu o limite de caracteres. 
            O número máximo permitido é de 255 caracteres`
          }
        }
      ],
      loadingRequest: false,
      dialogoAprovador: false,
      loadingAprovador: false,
      aprovadores: [],
      aprovadorSelecionado: "",
      dialogConfirmarAprovacao: false,
      dialogConfirmarReprovacao: false,
      regraEmpresa: [
        empresa => !!empresa || "A seleção de uma empresa é obrigatória."
      ],
      regraTipoDeMoeda: [
        moeda => !!moeda || "A seleção do tipo de moeda é obrigatória."
      ],
      regraNumeroDoPedido: [
        numero => !!numero || "Número de pedido é obrigatório.",
        numero => isNaN(numero) ? "Este campo só pode conter números" : true
      ],
      regraValorDoAdiantamento: [
        valor => !!valor || "Informar o valor recebido em adiantamento."
      ],
      fornecedorRecebido: {},
      snackbar: {
        ativo: false,
        timeout: 6000,
        text: "Salvo com successo!"
      }
    };
  },
  components: {
    componentRateioDespesas: RateioDespesas,
    componentDespesas: Despesas,
    LogsPedidos,
    IntegracaoMensagem,
    "c-box-fornecedor": BoxFornecedor
  },
  computed: {
    retornaTextoCorretoParaFinanceiro() {
      if (
        this.solicitacaoParaPrestarContas.status == "REPROVADO_PELO_PROCURADOR"
      )
        return "Para quem deseja enviar?";
      else return "Confirmar aprovação do pedido?";
    },
    verificaPerfilFinanceiro() {
      if (
        this.usuarioAutenticado.papeis.filter(
          papel => papel.nome === "APROVADOR_FINANCEIRO"
        ).length != 0 &&
        (this.solicitacaoParaPrestarContas.status == "ENVIADO_PARA_FINANCEIRO" ||
          this.solicitacaoParaPrestarContas.status == "REPROVADO_PELO_PROCURADOR")
      ) {
        return true;
      } else return false;
    },
    verificaAnexoContabilidade() {
      if (
        this.usuarioLogado.papeis.filter(
          papel => papel.nome === "APROVADOR_CONTABILIDADE"
        ).length != 0 &&
        this.solicitacaoParaPrestarContas.status == "ENVIADO_PARA_CONTABILIDADE"
      ) {
        return true;
      } else if (this.podeEditar) {
        return true;
      } else {
        return false;
      }
    },
    empresas() {
      return this.$store.getters.empresas;
    },
    usuarioAutenticado() {
      return this.$store.getters.usuarioAutenticado;
    },
    loadingCompanies() {
      return this.$store.getters.loadingCompanies;
    },
    passouNasRegrasDeValidacao() {
      if (
        this.validacaoDadosGerais &&
        this.solicitacaoParaPrestarContas.despesas.length > 0 &&
        this.arquivoAnexoEditandoOuNovo() &&
        this.solicitacaoParaPrestarContas.favorecido != null
      )
        return true;
      else return false;
    },
    totalDeDespesa() {
      return this.$store.getters.totalDeDespesa;
    },
    calculaValorAhDevolver() {
      let totalGastos = parseFloat(this.totalDeDespesa);

      let valorDoAdiantamento = this.solicitacaoParaPrestarContas
        .valorDoAdiantamento;

      valorDoAdiantamento = conversor.methods.converterValorStringEmNumero(
        valorDoAdiantamento,
        this.solicitacaoParaPrestarContas.tipoDeMoeda
      );

      let valorAhDevolver = 0;
      if (valorDoAdiantamento >= totalGastos) {
        valorAhDevolver = valorDoAdiantamento - totalGastos;
        this.solicitacaoParaPrestarContas.valorAhDevolver = valorAhDevolver;
      }
      this.solicitacaoParaPrestarContas.total = valorAhDevolver;
      return this.converteParaMoedaReal(valorAhDevolver);
    },

    calculaValorAcrescido() {
      let totalGastos = parseFloat(this.totalDeDespesa);
      let valorDoAdiantamento = this.solicitacaoParaPrestarContas
        .valorDoAdiantamento;

      valorDoAdiantamento = conversor.methods.converterValorStringEmNumero(
        valorDoAdiantamento,
        this.solicitacaoParaPrestarContas.tipoDeMoeda
      );

      let valorAcrescido = 0;
      if (valorDoAdiantamento <= totalGastos) {
        valorAcrescido = totalGastos - valorDoAdiantamento;
        this.solicitacaoParaPrestarContas.valorAcrescido = valorAcrescido;
      }

      const converterValorAcrescido = conversor.methods.converterParaMoedaReal(
        valorAcrescido.toFixed(2),
        this.solicitacaoParaPrestarContas.tipoDeMoeda
      );

      return converterValorAcrescido;
    }
  },
  methods: {
    alteraCampoValorRecebido(event, valor) {
      const valorRecebido = this.solicitacaoParaPrestarContas
        .valorDoAdiantamento;
      const valorAdiantamentoConvertido = conversor.methods.converterValorStringEmNumero(
        valorRecebido,
        this.solicitacaoParaPrestarContas.tipoDeMoeda
      );

      this.solicitacaoParaPrestarContas.valorDoAdiantamento = conversor.methods.converterParaMoedaReal(
        valorAdiantamentoConvertido,
        this.solicitacaoParaPrestarContas.tipoDeMoeda
      );
    },
    enviarArquivoClique() {
      this.$refs.files.click();
    },
    arquivoAnexoEditandoOuNovo() {
      if (this.solicitacaoParaPrestarContas.uploads.length > 0) return true;
      else {
        if (this.arquivoAnexado.length > 0) return true;
        else false;
      }
    },
    podeVisualizar() {
      let idDoUsuario = this.usuarioLogado.id;
      let papeis = this.usuarioLogado.papeis;
      let solicitacao = this.solicitacaoParaPrestarContas;

      if (idDoUsuario != solicitacao.idDoSolicitante) {
        if (
          papeis.filter(papel => papel.nome === "APROVADOR").length > 0 &&
          solicitacao.status === "ENVIADO_PARA_GESTOR"
        )
          return true;
        else if (
          papeis.filter(papel => papel.nome === "APROVADOR_FINANCEIRO_EXCECAO")
            .length > 0 &&
          solicitacao.status === "ENVIADO_PARA_ADM_FINANCEIRO"
        )
          return true;
        else if (
          papeis.filter(papel => papel.nome === "APROVADOR_FINANCEIRO").length >
          0 &&
          solicitacao.status === "ENVIADO_PARA_FINANCEIRO"
        )
          return true;
        else if (
          papeis.filter(papel => papel.nome === "APROVADOR_CONTABILIDADE")
            .length > 0 &&
          solicitacao.status === "ENVIADO_PARA_CONTABILIDADE"
        )
          return true;
        else if (
          papeis.filter(papel => papel.nome === "PROCURADOR").length > 0 &&
          solicitacao.status === "ENVIADO_PARA_PROCURADOR"
        )
          return true;
        else if (
          papeis.filter(papel => papel.nome === "APROVADOR_FINANCEIRO").length >
          0 &&
          (solicitacao.status === "REPROVADO_PELO_PROCURADOR" ||
            solicitacao.status === "APROVADO_PELO_PROCURADOR")
        )
          return true;
        else return false;
      } else {
        if (
          (papeis.filter(papel => papel.nome === "APROVADOR_FINANCEIRO_EXCECAO")
            .length > 0 &&
            solicitacao.status === "ENVIADO_PARA_ADM_FINANCEIRO") ||
          (papeis.filter(papel => papel.nome === "APROVADOR_FINANCEIRO")
            .length > 0 &&
            solicitacao.status === "ENVIADO_PARA_FINANCEIRO") ||
          (papeis.filter(papel => papel.nome === "APROVADOR_CONTABILIDADE")
            .length > 0 &&
            solicitacao.status === "ENVIADO_PARA_CONTABILIDADE") ||
          (papeis.filter(papel => papel.nome === "PROCURADOR").length > 0 &&
            solicitacao.status === "ENVIADO_PARA_PROCURADOR") ||
          (papeis.filter(papel => papel.nome === "APROVADOR_FINANCEIRO")
            .length > 0 &&
            (solicitacao.status === "REPROVADO_PELO_PROCURADOR" ||
              solicitacao.status === "APROVADO_PELO_PROCURADOR"))
        )
          return true;

        return false;
      }
    },
    async inicializa() {
      this.usuarioLogado = this.usuarioAutenticado;

      this.solicitacaoParaPrestarContas.idDoSolicitante = this.usuarioLogado.id;
      await this.$store.dispatch("get", {
        loaderName: "loadingCompanies",
        service: "/empresas",
        itemName: "empresas"
      });
    },
    async buscaPedidoDePrestacaoDeContas(id) {
      await axios({
        method: "get",
        url: `/pedidos/prestacaocontas/${id}`,
        responseType: "json",
        headers: {
          Authorization: `Bearer ${this.usuarioLogado.token}`,
          Accept: "application/json",
          "Content-Type": "application/json"
        }
      })
        .then(resposta => {
          const usuariosDoPedido = {
            idAprovador: resposta.data.idDoAprovador,
            idRegistrador: resposta.data.idDoSolicitante
          }
          if (validarSeUsuarioLogadoPodeVerPedido(usuariosDoPedido)) {
            this.solicitacaoParaPrestarContas = resposta.data;

            if (this.solicitacaoParaPrestarContas.logs && this.solicitacaoParaPrestarContas.logs.length > 0) {
              this.solicitacaoParaPrestarContas.logs = this.solicitacaoParaPrestarContas.logs.map(log => converterLogParaHorarioDeSaoPaulo(log));
            }
            
            if (this.solicitacaoParaPrestarContas.valorDoAdiantamento == "") {
              console.error("Não tem valor para ser formatado no Campo");
            } else {
              const valorDoAdiantamento = conversor.methods.converterValorStringEmNumero(
                this.solicitacaoParaPrestarContas.valorDoAdiantamento,
                this.solicitacaoParaPrestarContas.tipoDeMoeda
              );

              this.solicitacaoParaPrestarContas.valorDoAdiantamento = conversor.methods.converterParaMoedaReal(
                valorDoAdiantamento,
                this.solicitacaoParaPrestarContas.tipoDeMoeda
              );
            }

            let s = this.solicitacaoParaPrestarContas;
            let contasBancarias = [...resposta.data.dadosBancariosDoFornecedor];
            contasBancarias.map(c => {
              if (s.pagamento.conta.id == c.id) c.selecionado = true;
              else c.selecionado = false;
            });
            let filtrarContasAtivas = contasBancarias.filter(c => c.estaAtivo);
            let fornecedorComponente = {
              fornecedorDigitado: s.cnpj_cpf,
              fornecedor: {
                id: s.idDoFornecedor,
                nome: s.favorecido,
                dadosBancarios: [...filtrarContasAtivas]
              }
            };
            this.fornecedorRecebido = fornecedorComponente;
            this.configuraPermissaoParaEdicao();
          }
        })
        .catch(erro => { });
    },
    configuraPermissaoParaEdicao() {
      let usuarioEhUmAprovador =
        this.usuarioLogado.papeis.filter(
          papel => papel.nome.indexOf("APROVADOR") != -1
        ).length > 0;

      let usuarioEhProcurador =
        this.usuarioLogado.papeis.filter(
          papel => papel.nome.indexOf("PROCURADOR") != -1
        ).length > 0 &&
        this.solicitacaoParaPrestarContas.status == "ENVIADO_PARA_PROCURADOR";

      let mesmoAprovador =
        this.solicitacaoParaPrestarContas.idDoAprovador ==
        this.usuarioLogado.id;

      if (
        this.solicitacaoParaPrestarContas.status == "ENVIADO_PARA_GESTOR" &&
        mesmoAprovador
      ) {
        this.ehAprovador = true;
      } else {
        if (
          (usuarioEhUmAprovador || usuarioEhProcurador) &&
          this.solicitacaoParaPrestarContas.status != "ENVIADO_PARA_GESTOR"
        )
          this.ehAprovador = true;
      }

      let solicitacaoNova = this.solicitacaoParaPrestarContas.id === null;
      let usuarioEhSolicitante =
        this.usuarioLogado.id ===
        this.solicitacaoParaPrestarContas.idDoSolicitante;
      let prestacaoDeContasFoiReprovada =
        this.solicitacaoParaPrestarContas.status.indexOf("REPROVADO") != -1 &&
        this.solicitacaoParaPrestarContas.status != "REPROVADO_PELO_PROCURADOR";

      if (
        solicitacaoNova ||
        (usuarioEhSolicitante && prestacaoDeContasFoiReprovada)
      )
        this.podeEditar = true;
      else this.podeEditar = false;
    },
    buscarAprovadores() {
      this.dialogoAprovador = true;
      this.loadingAprovador = true;

      axios({
        method: "get",
        url: `/usuarios/${this.usuarioLogado.id}/papel/APROVADOR`,
        responseType: "json",
        headers: {
          Authorization: `Bearer ${this.usuarioLogado.token}`,
          Accept: "application/json",
          "Content-Type": "application/json"
        }
      })
        .then(resposta => {
          this.aprovadores = resposta.data;
        })
        .catch(erro => {
          console.error("Ocorreo um erro ao buscar aprovadores");
          console.error(erro);
        });

      this.loadingAprovador = false;
    },
    fechar() {
      this.dialogoAprovador = false;
      this.aprovadorSelecionado = "";
    },
    gerenciaStatusDaPrestacaoDeContas(operacao) {
      // solicitante
      if (
        operacao === "ENVIAR_PARA_APROVACAO" &&
        this.usuarioLogado.papeis.filter(papel => papel.nome === "SOLICITANTE")
          .length > 0
      ) {
        return "ENVIADO_PARA_GESTOR";
      }

      // aprovadores
      if (operacao === "APROVAR") {
        if (
          this.usuarioLogado.papeis.filter(papel => papel.nome === "APROVADOR")
            .length > 0 &&
          this.solicitacaoParaPrestarContas.status === "ENVIADO_PARA_GESTOR"
        ) {
          if (
            this.solicitacaoParaPrestarContas.statusDoFornecedor == "EM_ANALISE"
          )
            return "ENVIADO_PARA_ADM_FORNECEDOR";
          else return "ENVIADO_PARA_FINANCEIRO";
        }

        if (
          this.usuarioLogado.papeis.filter(
            papel => papel.nome === "APROVADOR_FINANCEIRO"
          ).length > 0 &&
          this.solicitacaoParaPrestarContas.status === "ENVIADO_PARA_FINANCEIRO"
        ) {
          return "ENVIADO_PARA_CONTABILIDADE";
        }

        if (
          this.usuarioLogado.papeis.filter(
            papel => papel.nome === "APROVADOR_CONTABILIDADE"
          ).length > 0 &&
          this.solicitacaoParaPrestarContas.status ===
          "ENVIADO_PARA_CONTABILIDADE"
        ) {
          return "ENVIADO_PARA_PROCURADOR";
        }

        if (
          this.usuarioLogado.papeis.filter(papel => papel.nome === "PROCURADOR")
            .length > 0 &&
          this.solicitacaoParaPrestarContas.status === "ENVIADO_PARA_PROCURADOR"
        ) {
          return "APROVADO_PELO_PROCURADOR";
        }
        //Temporario
        if (
          this.usuarioLogado.papeis.filter(
            papel => papel.nome === "APROVADOR_FINANCEIRO"
          ).length > 0 &&
          this.solicitacaoParaPrestarContas.status ===
          "REPROVADO_PELO_PROCURADOR"
        ) {
          return "ENVIADO_PARA_PROCURADOR";
        }
      }

      // reprovadores
      if (operacao === "REPROVAR") {
        if (
          this.usuarioLogado.papeis.filter(papel => papel.nome === "APROVADOR")
            .length > 0 &&
          this.solicitacaoParaPrestarContas.status === "ENVIADO_PARA_GESTOR"
        ) {
          return "REPROVADO_PELO_GESTOR";
        }

        if (
          this.usuarioLogado.papeis.filter(
            papel => papel.nome === "APROVADOR_FINANCEIRO"
          ).length > 0 &&
          (this.solicitacaoParaPrestarContas.status ===
            "ENVIADO_PARA_FINANCEIRO" ||
            this.solicitacaoParaPrestarContas.status ===
            "REPROVADO_PELO_PROCURADOR")
        ) {
          return "REPROVADO_PELO_FINANCEIRO";
        }

        if (
          this.usuarioLogado.papeis.filter(
            papel => papel.nome === "APROVADOR_CONTABILIDADE"
          ).length > 0 &&
          this.solicitacaoParaPrestarContas.status ===
          "ENVIADO_PARA_CONTABILIDADE"
        ) {
          return "REPROVADO_PELA_CONTABILIDADE";
        }

        if (
          this.usuarioLogado.papeis.filter(papel => papel.nome === "PROCURADOR")
            .length > 0 &&
          this.solicitacaoParaPrestarContas.status === "ENVIADO_PARA_PROCURADOR"
        ) {
          return "REPROVADO_PELO_PROCURADOR";
        }

        if (
          this.usuarioLogado.papeis.filter(
            papel => papel.nome === "APROVADOR_FINANCEIRO"
          ).length > 0 &&
          this.solicitacaoParaPrestarContas.status ===
          "APROVADO_PELO_PROCURADOR"
        ) {
          return "REPROVADO_PELO_PROCURADOR";
        }
      } else return operacao;
    },
    async prepararRequest(operacao) {
      this.loadingRequest = true;

      let solicitacaoCopia = Object.assign(
        {},
        this.solicitacaoParaPrestarContas
      );
      solicitacaoCopia.numeroDoPedido = substituirCaracteres(solicitacaoCopia.numeroDoPedido, 0, 30);
      solicitacaoCopia.idAprovadorLog = this.usuarioLogado.id;

      if (operacao === "ENVIAR_PARA_APROVACAO") {
        solicitacaoCopia.idDoAprovador = this.aprovadorSelecionado;
        this.dialogoAprovador = false;
      }

      this.dialogConfirmarAprovacao = false;

      if (operacao === "REPROVAR") {
        this.dialogConfirmarReprovacao = false;
      }

      solicitacaoCopia.cnpj_cpf = solicitacaoCopia.cnpj_cpf
        .replace(".", "")
        .replace(".", "")
        .replace("-", "")
        .replace("/", "");

      solicitacaoCopia.valorDoAdiantamento = parseFloat(
        conversor.methods.converterValorStringEmNumero(
          this.solicitacaoParaPrestarContas.valorDoAdiantamento,
          this.solicitacaoParaPrestarContas.tipoDeMoeda
        )
      );
      solicitacaoCopia.status = this.gerenciaStatusDaPrestacaoDeContas(
        operacao
      );
      solicitacaoCopia.despesas.map(item => {
        item.rateio.valor = parseFloat(item.rateio.valor).toFixed(2);
      });

      solicitacaoCopia.valorAcrescido = solicitacaoCopia.valorAcrescido.toFixed(
        2
      );
      await this.fazerRequest(solicitacaoCopia);
    },
    async fazerRequest(dados) {
      let operacaoHTTP = "POST";
      this.loadingRequest = true;
      if (this.solicitacaoParaPrestarContas.id != null) operacaoHTTP = "PUT";

      this.snackbar.ativo = true;
      this.snackbar.color = "primary";
      this.snackbar.text = "Carregando...";

      await axios({
        method: `${operacaoHTTP}`,
        url: `/pedidos/prestacaocontas`,
        responseType: "json",
        headers: {
          Authorization: `Bearer ${this.usuarioLogado.token}`,
          Accept: "application/json",
          "Content-Type": "application/json"
        },
        data: JSON.stringify(dados)
      })
        .then(resposta => {
          this.snackbar.ativo = false;
          this.snackbar.color = "success";
          this.snackbar.text = "Salvo com Sucesso!";
          this.snackbar.ativo = true;
          let vm = this;
          this.snackbar.ativo = true;

          // caso tenha anexado arquivo
          if (this.arquivoAnexado.length > 0) {
            const anexosFormData = this.converterAnexosEmFormData();
            const idPedido = resposta.data.id;
          
            this.salvarAnexos(idPedido, anexosFormData)
          }

          setTimeout(function () {
            vm.$router.push({ name: `solicitacoes` });
          }, 2000);
        })
        .catch(erro => {
          this.snackbar.color = "error";

          this.snackbar.text = `Houve um erro na criação / envio do pedido. Para mais informações entre em contato com o Administrador.`;
          const erroPossuiResposta = erro.response == !undefined
          if (erroPossuiResposta) {
            const codigoErro = erro.response.status;
            const ehErroIntegracao = codigoErro == 502;
            if (ehErroIntegracao) {
              this.solicitacaoParaPrestarContas.statusIntegracao =
                erro.response.data.statusIntegracao;
              this.solicitacaoParaPrestarContas.mensagemIntegracao =
                erro.response.data.mensagemIntegracao;
              this.snackbar.text = `Houve um erro na integração do pedido.`;
            }
          }
          this.loadingRequest = false;
          this.snackbar.ativo = true;
        });
    },
    receberFornecedor(event) {
      let contaCorreta = event.dadosBancarios.filter(
        i => i.selecionado == true
      );
      const dadosBancarios = contaCorreta[0];
      this.solicitacaoParaPrestarContas.dadosBancariosDoFornecedor =
        event.dadosBancarios;
      this.solicitacaoParaPrestarContas.pagamento.conta.id = dadosBancarios.id;
      this.solicitacaoParaPrestarContas.idDoFornecedor = event.id;
      this.solicitacaoParaPrestarContas.favorecido = event.nome;
    },
    buscaDadosBancarios() {
      this.loadingBusca = true;
      if (
        this.solicitacaoParaPrestarContas.cnpj_cpf == null ||
        this.solicitacaoParaPrestarContas.cnpj_cpf == ""
      ) {
        this.loadingBusca = false;
        return;
      }

      let numeroDocumento = this.solicitacaoParaPrestarContas.cnpj_cpf
        .replace(".", "")
        .replace(".", "")
        .replace("-", "")
        .replace("/", "");
      axios({
        method: "GET",
        url: `/fornecedores/dadosbancario/busca/${numeroDocumento}`,
        responseType: "json",
        headers: {
          Authorization: `Bearer ${this.usuarioLogado.token}`,
          Accept: "application/json",
          "Content-Type": "application/json"
        }
      })
        .then(resposta => {
          const dadosBancarios = resposta.data.dadoBancario;
          this.solicitacaoParaPrestarContas.banco = dadosBancarios.banco.nome;
          this.solicitacaoParaPrestarContas.agencia = dadosBancarios.agencia;
          this.solicitacaoParaPrestarContas.contaCorrente =
            dadosBancarios.conta;
          this.solicitacaoParaPrestarContas.idDoFornecedor = resposta.data.id;
          this.solicitacaoParaPrestarContas.favorecido = resposta.data.nome;
          this.loadingBusca = false;
        })
        .catch(erro => {
          console.error("Ocorreu um erro ao tentar buscar por fornecedor");
          console.error(erro);
          this.solicitacaoParaPrestarContas.banco = "";
          this.solicitacaoParaPrestarContas.agencia = "";
          this.solicitacaoParaPrestarContas.contaCorrente = "";
          this.solicitacaoParaPrestarContas.idDoFornecedor = "";
          this.solicitacaoParaPrestarContas.favorecido = "";
          this.loadingBusca = false;
        });
    },
    upload(nome) {
      let arquivos = this.$refs[nome].files;
      let foiValidado = true;
      let nomeDoArquivo = "";
      let erroMsg = "";
      let somaNovosArquivos = 0;
      let somaTamanhoTotal = 0;

      for (let index = 0; index < arquivos.length; index++) {
        const itemArray = arquivos[index];
        if (itemArray.size >= 50000000) {
          nomeDoArquivo = itemArray.name;
          erroMsg = `O arquivo ${nomeDoArquivo} ultrapassou o tamanho máximo de 50MB de anexos.`;
          foiValidado = false;
          break;
        }
        somaNovosArquivos += itemArray.size;
      }

      for (let index = 0; index < this.arquivoAnexado.length; index++) {
        let itemJaInserido = this.arquivoAnexado[index];
        somaTamanhoTotal += this.arquivoAnexado[index].size;
      }
      if (somaNovosArquivos + somaTamanhoTotal >= 50000000) {
        erroMsg = `Limite máximo de anexo excedido. Permitido no máximo até 50MB.`;
        foiValidado = false;
      }
      if (foiValidado) {
        this.arquivoAnexado = [...this.arquivoAnexado, ...arquivos];
        this.msgErroAnexo = "";
      } else this.msgErroAnexo = erroMsg;
    },
    converteValorStringEmNumero(valor) {
      if (typeof valor != "string") return valor;

      valor = valor
        .replace("R$", "")
        .replace("$", "")
        .replace("￥", "")
        .replace("€", "")
        .replace("£", "")
        .replace("S$", "")
        .replace("Mex$", "");
      if (this.solicitacaoParaPrestarContas.tipoDeMoeda.indexOf("BRL") != -1) {
        valor = valor.replace(/\./g, "");
        valor = valor.replace(",", ".");
      } else if (
        this.solicitacaoParaPrestarContas.tipoDeMoeda.indexOf("EUR") != -1
      ) {
        valor = valor.replace(/\s/g, "");
        valor = valor.replace(",", ".");
      } else {
        valor = valor.replace(/\,/g, "");
      }

      if (isNaN(valor)) {
        valor = 0;
        return valor;
      }
      return valor;
    },
    converteParaMoedaReal(numero) {
      let formatter;
      if (this.solicitacaoParaPrestarContas.tipoDeMoeda == "USD")
        formatter = this.converterOutrasMoedas("en-US", "currency", "USD");
      else if (this.solicitacaoParaPrestarContas.tipoDeMoeda == "AUD")
        formatter = this.converterOutrasMoedas("en-au", "currency", "AUD");
      else if (this.solicitacaoParaPrestarContas.tipoDeMoeda == "CAD")
        formatter = this.converterOutrasMoedas("en-ca", "currency", "CAD");
      else if (this.solicitacaoParaPrestarContas.tipoDeMoeda == "JPY")
        formatter = this.converterOutrasMoedas("ja", "currency", "JPY");
      else if (this.solicitacaoParaPrestarContas.tipoDeMoeda == "EUR")
        formatter = this.converterOutrasMoedas("fr", "currency", "EUR");
      else if (this.solicitacaoParaPrestarContas.tipoDeMoeda == "GBP")
        formatter = this.converterOutrasMoedas("en-gb", "currency", "GBP");
      else if (this.solicitacaoParaPrestarContas.tipoDeMoeda == "SGD")
        formatter = this.converterOutrasMoedas("zh-sg", "currency", "SGD");
      else if (this.solicitacaoParaPrestarContas.tipoDeMoeda == "MXN")
        formatter = this.converterOutrasMoedas("es-mx", "currency", "MXN");
      else formatter = this.converterOutrasMoedas("pt-BR", "currency", "BRL");
      return formatter.format(numero);
    },

    converterOutrasMoedas(linguagem, estilo, pais) {
      return new Intl.NumberFormat(linguagem, {
        style: estilo,
        currency: pais,
        minimumFractionDigits: 2
      });
    },
    formataValorRecebidoDeAdiantamento(eventoBlur) {
      const valorConvertido = conversor.methods.converterValorStringEmNumero(
        eventoBlur.target.value,
        this.solicitacaoParaPrestarContas.tipoDeMoeda
      );

      this.solicitacaoParaPrestarContas.valorDoAdiantamento = conversor.methods.converterParaMoedaReal(
        valorConvertido,
        this.solicitacaoParaPrestarContas.tipoDeMoeda
      );

      return this.solicitacaoParaPrestarContas.valorDoAdiantamento;
    },
    salvarAnexos(idPedido, anexos) {
      console.log('------SALVANDO ANEXO------')
      axios({
        method: "post",
        url: `/uploads/pedidos/${idPedido}`,
        headers: {
          "Content-Type": "multipart/form-data"
        },
        data: anexos
      })
      .then(() => console.log('ANEXO SALVO COM SUCESSO'))
      .catch((erro) => {
        console.log('------ERRO DE ANEXO ABAIXO------')
        console.log(erro)
        console.log(erro.response)
      })
    },
    converterAnexosEmFormData() {
      let formData = new FormData();
      for (let i = 0; i < this.arquivoAnexado.length; i++) {
        formData.append("arquivos", this.arquivoAnexado[i]);
      }
      return formData;
    }
  },
  async created() {
    await this.inicializa();

    if (this.$route.params.id !== undefined)
      await this.buscaPedidoDePrestacaoDeContas(this.$route.params.id);
  },
  watch: {
    // "solicitacaoParaPrestarContas.tipoDeMoeda"(valorAtual, valorAntigo) {
    //   let valor = this.solicitacaoParaPrestarContas.valorDoAdiantamento;
    //   valor = valor
    //     .replace("R$", "")
    //     .replace("$", "")
    //     .replace("￥", "")
    //     .replace("€", "")
    //     .replace("£", "")
    //     .replace("S$", "")
    //     .replace("Mex$", "");
    //   if (valorAntigo.indexOf("BRL") != -1) {
    //     valor = valor.replace(/\./g, "");
    //     valor = valor.replace(",", ".");
    //   } else if (valorAntigo.indexOf("EUR") != -1) {
    //     valor = valor.replace(/\s/g, "");
    //     valor = valor.replace(",", ".");
    //   } else {
    //     valor = valor.replace(/\,/g, "");
    //   }
    //   this.solicitacaoParaPrestarContas.valorDoAdiantamento = this.converteParaMoedaReal(
    //     valor
    //   );
    // }
  }
};
</script>
<style>
.flex {
  padding: 0px 16px;
}

.noDataSlot {
  font-size: 1em;
  padding: 10px;
}
</style>